import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';

var SettingRowColumnComponent = function (_a) {
    var children = _a.children, position = _a.position, rest = __rest(_a, ["children", "position"]);
    return (React.createElement("div", __assign({ className: "pgc-setting-row-column ".concat(position) }, rest), children));
};
/**
 * @name Span
 * @param {string} text
 * @constructor
 */
var Span = function (_a) {
    var text = _a.text;
    return React.createElement("span", { className: 'pgc-setting-name' }, text);
};
/**
 * @name Switcher
 * @param {boolean} isChecked
 * @param {Function} handler
 */
var Switcher = function (_a) {
    var isChecked = _a.isChecked, handler = _a.handler;
    return React.createElement("div", { onClick: handler, className: "pgc-switcher ".concat(isChecked ? 'active' : '') });
};
/**
 * @name Range
 * @param {*} value
 * @param {number} width
 * @param {string} rangeColorType
 * @param {Function} handler
 * @param {number=} min
 * @param {number=} max
 * @param {number=} step
 */
var Range = function (_a) {
    var value = _a.value, width = _a.width, rangeColorType = _a.rangeColorType, handler = _a.handler, _b = _a.min, min = _b === void 0 ? 0 : _b, _c = _a.max, max = _c === void 0 ? 1 : _c, _d = _a.step, step = _d === void 0 ? 0.1 : _d;
    return (React.createElement("div", { className: "pgc-f-c-min-max-line ".concat(rangeColorType) },
        React.createElement("div", { className: 'pgc-range-wrp' },
            React.createElement("input", { min: min, max: max, step: step, value: value, type: 'range', className: 'pgc-inp-range-s', onChange: handler })),
        React.createElement("div", { className: 'pgc-inp-range-line-wr', style: { width: "".concat(width, "%") } },
            React.createElement("div", { className: 'pgc-inp-range-line-sp' }))));
};
/**
 * @name Icon
 * @param iconName
 * @param onClick
 */
var Icon = function (_a) {
    var iconName = _a.iconName, onClick = _a.onClick;
    return React.createElement("i", { onClick: onClick, className: "".concat(iconName, " pgc-setting-icon") });
};
var SettingRowColumn = Object.assign(SettingRowColumnComponent, {
    Span: Span,
    Switcher: Switcher,
    Range: Range,
    Icon: Icon,
});

export { SettingRowColumn, SettingRowColumnComponent };
